<template>
  <commonAnnouncementDetail
    :pageData="pageData"
    :currBreadCrumb="currBreadCrumb"
    :fileData="fileData"
  ></commonAnnouncementDetail>
</template>

<script>
import { selectPulicBidNoticeDetail } from "@/app/shop/api/shopping";
import commonAnnouncementDetail from "@/app/shop/components/commonAnnouncementDetail.vue";
import { mapGetters } from "vuex";
export default {
  name: "questionOrManualDetail",
  components: {
    commonAnnouncementDetail
  },
  data() {
    return {
      pageData: {},
      fileData: []
    };
  },
  computed: {
    ...mapGetters({
      currBreadCrumb: "getCurrentBrand"
    })
  },
  activated() {
    this.init();
  },
  deactivated() {},
  methods: {
    init() {
      selectPulicBidNoticeDetail({
        noticeId: this.$route.query.noticeId,
        type: this.$route.query.type,
        isShowLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.pageData = {
            source: res.data.data.source,
            title: res.data.data.noticeTitle,
            author: res.data.data.createName,
            publishTime: res.data.data.noticeStartTime.slice(0, -3),
            textContent: res.data.data.textInfo
          };
          this.fileData = res.data.data.basFileRelationBOs;
          this.fileData = res.data.data.basFileRelationBOs.map(item => {
            item.uploadId = item.fileInfoId;
            item.fileSize = Math.round(item.fileSize / 1024);
            return item;
          });
          this.$store.dispatch("setAutoBrand", {
            title: this.pageData.title
          });
        }
      });
    }
  }
};
</script>

<style scoped></style>
